import type { SchemaUserResolver_GetAdvisersByRole } from 'cpool-tables/backend-resolvers';

type NamedAdviser = Pick<SchemaUserResolver_GetAdvisersByRole[number], 'firstName' | 'id' | 'lastName'>;

export const getAdviserName = (advisers: NamedAdviser[], userId: string, unknownName: string) => {
    const adviser = advisers.find(({ id }) => id === userId);
    return adviser ? `${adviser.firstName} ${adviser.lastName}` : unknownName;
};
